import createReducer, { ActionCreatorHelper } from '@hh.ru/redux-create-reducer';

const INITIAL_STATE = 0;

const SET_FILTERS_HEIGHT = 'SET_FILTERS_HEIGHT';

interface PayloadTypes {
    [SET_FILTERS_HEIGHT]: number;
}

const actionCreator = ActionCreatorHelper<PayloadTypes>();
export const setFiltersIsReady = actionCreator(SET_FILTERS_HEIGHT);

export default createReducer<number, PayloadTypes>(INITIAL_STATE, {
    [SET_FILTERS_HEIGHT]: (_, { payload }) => payload,
});
